import styled, { css } from 'styled-components'

type IsMobile = {
  isMobile: boolean
}

export const Container = styled.div<IsMobile>`
  margin: 3rem 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;

  ${({ isMobile }) => isMobile && css`
    flex-direction: column;
    gap: 10px;
    margin-top: 3rem;
  `}
`

export const IconsWrapper = styled.div<IsMobile>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`

export const TextWrapper = styled.div<IsMobile>`
  display: flex;
  align-items: baseline;
  gap: 5px;

  & > button {
    height: 0;
    padding: 0;
  }

  ${({ isMobile }) => isMobile && css`
    flex-direction: column;
    gap: 5px;
    align-items: center;
    max-width: 250px;
  `}
`